(function () {
  if (window.lcConditionLabelsLoaded) return;
  window.lcConditionLabelsLoaded = true;

  var labelMaps = {
    en: {
      mint: 'Mint',
      'near-mint': 'Near Mint',
      excellent: 'Excellent',
      'lightly-played': 'Lightly Played',
      'moderately-played': 'Moderately Played',
      'heavily-played': 'Heavily Played',
      damaged: 'Damaged'
    },
    nl: {
      mint: 'Nieuwstaat',
      'near-mint': 'Near Mint',
      excellent: 'Lichte gebruikssporen',
      'lightly-played': 'Zichtbaar gebruikt',
      'moderately-played': 'Licht gespeeld',
      'heavily-played': 'Zwaar gespeeld',
      damaged: 'Sterk beschadigd'
    },
    de: {
      mint: 'Neuwertig',
      'near-mint': 'Nahezu neuwertig',
      excellent: 'Sehr gut',
      'lightly-played': 'Leicht gespielt',
      'moderately-played': 'Mäßig gespielt',
      'heavily-played': 'Stark gespielt',
      damaged: 'Beschädigt'
    },
    fr: {
      mint: 'Neuve',
      'near-mint': 'Quasi neuve',
      excellent: 'Excellente',
      'lightly-played': 'Légèrement jouée',
      'moderately-played': 'Modérément jouée',
      'heavily-played': 'Très jouée',
      damaged: 'Endommagée'
    },
    es: {
      mint: 'Nueva',
      'near-mint': 'Casi nueva',
      excellent: 'Excelente',
      'lightly-played': 'Poco jugada',
      'moderately-played': 'Moderadamente jugada',
      'heavily-played': 'Muy jugada',
      damaged: 'Dañada'
    },
    it: {
      mint: 'Nuova',
      'near-mint': 'Quasi nuova',
      excellent: 'Eccellente',
      'lightly-played': 'Poco giocata',
      'moderately-played': 'Moderatamente giocata',
      'heavily-played': 'Molto giocata',
      damaged: 'Danneggiata'
    }
  };

  var aliases = {
    mint: ['mint', 'mt', 'nieuwstaat', 'neuwertig', 'neuve', 'nueva', 'nuova'],
    'near-mint': ['near mint', 'near-mint', 'nm', 'bijna nieuw', 'nahezu neuwertig', 'quasi neuve', 'casi nueva', 'quasi nuova'],
    excellent: ['excellent', 'ex', 'lichte gebruikssporen', 'sehr gut', 'excellente', 'excelente', 'eccellente'],
    'lightly-played': ['good', 'slightly played', 'slightly-played', 'lightly played', 'lightly-played', 'gd', 'zichtbaar gebruikt', 'leicht gespielt', 'légèrement jouée', 'poco jugada', 'poco giocata'],
    'moderately-played': ['light played', 'light-played', 'moderately played', 'moderately-played', 'lp', 'mp', 'licht gespeeld', 'mäßig gespielt', 'modérément jouée', 'moderadamente jugada', 'moderatamente giocata'],
    'heavily-played': ['played', 'heavily played', 'heavily-played', 'pl', 'hp', 'zwaar gespeeld', 'stark gespielt', 'très jouée', 'muy jugada', 'molto giocata'],
    damaged: ['poor', 'damaged', 'po', 'dmg', 'sterk beschadigd', 'beschädigt', 'endommagée', 'dañada', 'danneggiata']
  };

  var aliasKeys = {};
  var locale = String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var labels = labelMaps[locale] || labelMaps.en;

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  }

  Object.keys(aliases).forEach(function (key) {
    aliases[key].forEach(function (alias) {
      aliasKeys[normalize(alias)] = key;
    });
  });

  function conditionKey(value) {
    return aliasKeys[normalize(value)] || '';
  }

  function translateSegment(value) {
    var segment = String(value || '');
    var leading = segment.match(/^\s*/)[0];
    var trailing = segment.match(/\s*$/)[0];
    var end = trailing.length ? segment.length - trailing.length : segment.length;
    var core = segment.slice(leading.length, end);
    var key = conditionKey(core);
    var countSuffix = '';

    if (!key) {
      var counted = core.match(/^(.*?)(\s+\(\s*\d[\d.,]*(?:\s+[^)]*)?\))$/);
      if (counted) {
        key = conditionKey(counted[1]);
        countSuffix = counted[2];
      }
    }

    if (!key) return segment;
    return leading + labels[key] + countSuffix + trailing;
  }

  function translateText(value) {
    var text = String(value || '');
    var exact = translateSegment(text);
    if (exact !== text) return exact;

    var slashParts = text.split(/(\s*\/\s*)/);
    for (var index = 0; index < slashParts.length; index += 2) {
      slashParts[index] = translateSegment(slashParts[index]);
    }
    var withSlashes = slashParts.join('');
    if (withSlashes !== text) return withSlashes;

    return text.replace(/(:\s*)([^:]+)$/, function (match, prefix, suffix) {
      var translated = translateSegment(suffix);
      return translated === suffix ? match : prefix + translated;
    });
  }

  var selector = [
    '[data-selected-value]',
    '[data-lc-condition-label]',
    '.facet-checkbox__text-label',
    '.lc-facet-accessible',
    '[data-lc-active-facet-label]',
    '.facet-checkbox .visually-hidden',
    '.mobile-facets__label .visually-hidden',
    '.swatch-input__label .visually-hidden',
    '.facets__selected',
    '.active-facets__button-inner',
    '.product-edit-title-variant'
  ].join(',');

  function translateElement(element) {
    if (!(element instanceof Element)) return;
    if (element.matches(selector)) {
      var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        var translated = translateText(node.nodeValue);
        if (translated !== node.nodeValue) node.nodeValue = translated;
      }
    }
    ['aria-label', 'title', 'data-label'].forEach(function (attribute) {
      if (!element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var translated = translateText(current);
      if (translated !== current) element.setAttribute(attribute, translated);
    });
  }

  function scan(root) {
    if (root instanceof Element) translateElement(root);
    if (!(root instanceof Element || root instanceof Document)) return;
    root.querySelectorAll(selector).forEach(translateElement);
    root.querySelectorAll('[aria-label], [title], [data-label]').forEach(translateElement);
  }

  function start() {
    scan(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          translateElement(mutation.target.parentElement);
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) scan(node);
        });
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  window.lcConditionLabels = {
    conditionKey: conditionKey,
    labelFor: function (key) {
      return labels[key] || '';
    },
    translateText: translateText
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
